import React ,{Component} from 'react'; 
import Serverurl from './Apiurl';
import axios from 'axios'; 
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from 'dayjs';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
 
 
export default class CustomerbyBranch extends Component {
	   constructor(props) {
      super(props);
	  this.state ={classtype:'',sbid:'',smid:'',serachdate:'', orderdata: [],subscribeData:[],subscribeslotData:[], searchdate: dayjs().format('YYYY-MM-DD'), customerdata: [],branchid:'',classTypes:[] }
	   };

/*myChangeHandler = (event) => {
  const { name, value } = event.target;
  this.setState({ [name]: value }, () => {
    if (name === 'classtype') {
      this.filterDurations(value);
      this.setState({ smid: '', sbid: '' }); // Reset slot and duration
    } else if (name === 'sbid') {
      this.filterSlots(this.state.classtype, value);
      this.setState({ smid: '' }); // Reset slot
    }
  });
};*/

myChangeHandler = (event) => {
  const { name, value } = event.target;
  this.setState({ [name]: value }, () => {
    if (name === 'classtype') {
      this.filterSlots(value); 
      this.setState({ smid: '' }); 
    }
    
  });
};

componentDidMount  () {
	this.loadClassTypes();
}
handleClickSearch=()=>{  
  
  this.apiOrdercall();

  } 
handdateChanges = (newValue) => {
  this.setState({
    searchdate: dayjs(newValue).format('YYYY-MM-DD') 
  });
};

filterDurations = () => {
  axios.post(Serverurl + 'ajaxsubscription.php?action=getall&sb_type=' +this.state.classtype +'&sb_bm_id='+localStorage.getItem("AYLbrid")+'&sorting=sb_type')
    .then(resp => {
      if (resp.data.length > 0) {
        const formatted = resp.data.map(row => ({
          value: row.sb_id,
          display: row.sb_title,
         
        }));
        this.setState({
          subscribeData: [{ value: '', display: 'Select Duration' }, ...formatted]
        });
      } else {
        this.setState({ subscribeData: [] });
      }
    });
};

filterSlots = () => {
	
  axios.post(Serverurl + 'ajaxslotmanagement.php?action=getall&sm_slottype='+this.state.classtype+'&sbid='+this.state.sbid+'&sm_bm_id='+localStorage.getItem("AYLbrid")+'&sorting=sm_order asc')
    .then(resp => {
      if ( resp.data.length > 0) {
        const formatted = resp.data.map(row => ({
          value: row.sm_id,
          display: row.sm_slotname,
         
        }));
        this.setState({
          subscribeslotData: [{ value: '', display: 'Select Slot' }, ...formatted]
        });
      } else {
        this.setState({ subscribeslotData: [] });
      }
    });
};
loadClassTypes = () => {
  const branchId = localStorage.getItem("AYLbrid");

  axios.get(Serverurl + 'ajaxorders.php?action=list&or_bm_id=' + branchId)
    .then(resp => {
      if (resp.data.length > 0) {
        const classTypes = resp.data.map(row => ({
          value: row.or_classtype,
		  
        }));
        this.setState({ classTypes: classTypes });
      } else {
        this.setState({ classTypes: [] });
      }
    });
}
apiOrdercall(){

	 axios.get(Serverurl+'ajaxorders.php?action=customerbybranch&or_classtype='+this.state.classtype+'&or_sm_id='+this.state.smid+'&searchdate='+this.state.searchdate+'&or_bm_id='+localStorage.getItem("AYLbrid"))
	 
     
	
  .then(resp => {  
		 console.log(resp.data);
    if(resp.data.length>0){
			this.setState({  
			  orderdata: resp.data,  
			   //totaldata:parseInt(resp.data[0].count)
		    });
     }
	 else{
		   this.setState({orderdata:[]});
	 }

    });
}
	handleCustomerData = () => {
		
		let strrerun="",strsep="";
 this.state.orderdata.map(customer => {
	  
	  
	  strrerun=strrerun+strsep+customer.cs_id+"~"+customer.cs_or_id+"~"+customer.isChecked;
   strsep=";";
  });
		   var formData = new FormData();
		    formData.append('action','updatecheckvalue');
			 formData.append('v_str',strrerun);
			  
   axios.post(Serverurl + 'ajaxcustomerschedule.php',formData, {
      })
      .then((response) => {
         alert("Attendance updated");
        this.setState({ customerdata: [] }); 
      })
};

handleCheckBox = (cs_id, rowsid) => {
  const updatedArray = [...this.state.orderdata];





  if (updatedArray[rowsid].isChecked === "0") {
    // Add if not already added
   updatedArray[rowsid].isChecked="1";
  } else {
    // Remove if unchecked
  updatedArray[rowsid].isChecked="0";
  }

  this.setState({
    orderdata: updatedArray,

  }, () => {
    console.log("Updated customerdata for submit:", this.state.customerdata);
  });
};



	render() {
		 let prev="";
  return (
  <React.Fragment>
  		  <div className="boxheading">
				 
<h2>Attendance</h2>
</div>
 <div className="clear"></div>
    <div className="searchmaster">
      <ul>
      
          <li>
            <p>Class Type</p>
            <p>
              <FormControl className="stadrp">
                <Select
                  native
                  variant="outlined"
                  inputProps={{ tabIndex: "2" }}
                  className="txtbox"
                  margin="normal"
                  onChange={this.myChangeHandler}
                  id="type"
                  value={this.state.classtype}
                  name="classtype"
                >
                  <option value="">Select Your Type</option>
                  <option value={1}>Personal Training at Home</option>
                  <option value={2}>Personal Training in Studio</option>
                  <option value={3}>Group</option>
                  <option value={4}>Prenatal</option>
                  <option value={5}>Products</option>
                  <option value={6}>Personal Training Online</option>
                  <option value={7}>TTC</option>
                </Select>
              </FormControl>
            </p>
          </li>
		  {/*  <li><p>Duration</p>
 
<Select
  className="txtbox"
  native
  value={this.state.sbid}
  onChange={this.myChangeHandler}
  name="sbid"
>
  {this.state.subscribeData.map((row, index) => (
    <option key={index} value={row.value}>
      {row.display}
    </option>
  ))}
</Select>
	</li>*/}
		  <li><p>Select Slot</p>
 
 <Select
  className="txtbox"
  native
  value={this.state.smid}
  onChange={this.myChangeHandler}
  name="smid"
>
  {this.state.subscribeslotData.map((row, index) => (
    <option key={index} value={row.value}>
      {row.display}
    </option>
  ))}
</Select>
</li>
		<li>
 <p>Date</p>

<p> <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker
value={dayjs(this.state.searchdate)}

className="txtbox" 
    onChange={this.handdateChanges} format="DD/MM/YYYY"  minDate={dayjs()}         
  maxDate={dayjs()}         	
/>  </DemoContainer>
    </LocalizationProvider>
</p>
 </li>
 <li><p >
		<Button variant="contained" onClick={this.handleClickSearch} className="frmSecondarybtn" endIcon={<SearchIcon />}>
        Search
      </Button></p></li> 
      </ul>

	
	{Array.isArray(this.state.orderdata) && this.state.orderdata.length > 0 ? (
  <table className="customer-table" style={{ marginTop: '50px' , width: '80%', borderCollapse: 'collapse' }}>
  <thead>
      <tr>
        <th style={{ textAlign: 'left' }}></th>
        <th style={{ textAlign: 'left' }}>Name</th>
        <th style={{ textAlign: 'left' }}>Phone</th>
        <th style={{ textAlign: 'left' }}>Email</th>
      </tr>
    </thead>
    <tbody>
      {this.state.orderdata.map((customer, index) => (
        <tr key={index}>
          <td>
            <Checkbox
              checked={customer.isChecked === "1"}
              onChange={() => this.handleCheckBox(customer.cs_id, index)}
              inputProps={{ 'aria-label': 'controlled' }}
            />
          </td>
          <td>{customer.or_name}</td>
          <td>{customer.or_phone}</td>
          <td>{customer.or_email}</td>
        </tr>
      ))}
    </tbody>
  </table>
) : (
  <div style={{ textAlign: 'center', marginTop: '20px' }}>No records</div>
)}


<Button
  className="frmSecondarybtn"
  onClick={this.handleCustomerData}
  sx={{ 
    mt: 2, 
    display: 'block', 
    mx: 'auto' 
  }}
>
  Submit
</Button>

    </div>
	</React.Fragment>
  );
}

}